import { render, staticRenderFns } from "./SearchCategories.vue?vue&type=template&id=b9c5591e&"
import script from "./SearchCategories.vue?vue&type=script&lang=ts&"
export * from "./SearchCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports